// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__12UrS","inputWrap":"styles_inputWrap__3pXtB","input":"styles_input__3p12K"};